export const phonenumber = new RegExp(
  /(?:^((?!00|[+])|(?:(?:00|[+])47))(\d{8})$)|(?:^(?:00|[+])(?!47)(\d{7,15})$)/
)

export const mobilenumber = new RegExp(
  /(?:^((?!00|[+])|(?:(?:00|[+])47))([49]\d{7})$)|(?:^(?:00|[+])(?!47)([49]\d{7,15})$)/
)

export const exclusiveNumbers = new RegExp(/^\d+$/)

export const date = new RegExp(
  /^(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.]\d{4}|(0[1-9]|[1-2][0-9]|31(?!(?:0[2469]|11))|30(?!02))(0[1-9]|1[0-2])([12]\d{3})|([01][0-9]|2[0-8])(0[0-9]|1[0-2])[0-9][0-9]|30(0[013-9]|1[0-2])[0-9][0-9]|31(0[13578]|1[02])[0-9][0-9]|29((0[013-9]|1[0-2])[0-9][0-9]|02([0246][048]|[13579][26]))|(0[1-9]|[12][0-9]|3[01])[.](0[1-9]|1[012])[.]\d{2}$/
)

export const email = new RegExp(
  /(?:[^<>()[\]\\.,;:\s@"]+(?:\.[^<>()[\]\\.,;:\s@"]+)*@(?:[a-zA-ZæÆøØåÅ0-9-]+\.)+[a-zA-Z]{2,}(?:\s?[;,:\s]\s?)?)+/
)

export const year = new RegExp(/^[12][0-9]{3}$/)

export const url = new RegExp(
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{2,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/
)

export const emoji = new RegExp(
  /(?![©®](?!\uFE0F))(\p{Emoji_Presentation}|\p{Extended_Pictographic})/gu
)
